const OVERRIDE_RATE = 15;

export default OVERRIDE_RATE;
